<template>
    <div class="team-list">
        <h4 class="title">
            {{$t("planLxDetail.TDXX")}}
        </h4>
        <div class="list-box">
            <template v-if="listArr.length">
                <list-item v-for="item in listArr" :pageBtnStatusDto="pageBtnStatusDto" :planDto="planDto" :key="item.initKeyId" :itemData="item"></list-item>
            </template>
           <div class="null-list" v-else>
               <img src="@/assets/image/null-list.png" />
           </div>
        </div>
    </div>
</template>
<script>
import listItem from '@/views/planLxDetail/list-item'
export default {
    name: 'teamList',
    components:{
        listItem
    },
    props: {
        listArr: Array,
        planDto: Object,
        pageBtnStatusDto: Object
    }
}
</script>
<style scoped lang="scss">
.title{
    font-size: 16px;
    font-family: 'Hiragino Sans GB';
    font-weight: normal;
    line-height: 6px;
    color: #0D141E;
    letter-spacing: 1px;
}
.list-box{
    box-sizing: border-box;
    height: calc(100vh - 444px);
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    flex-direction: row;
    align-content: flex-start;
    overflow: auto;
    .null-list{
        width: 32%;
        margin: 0 auto;
    }
}
</style>